import Select from '../Select/Select';

// Счётчик показываем только в раскрытом списке: в самом поле и в строке применённых
// фильтров он бы устаревал после каждого следующего выбора.
const formatOptionLabel = (option, meta) =>
  meta?.context === 'menu' && option?.count != null ? `${option.label} (${option.count})` : option?.label;

/**
 * Селект фильтра стока. Варианты приходят готовыми с бэка вместе с количеством машин
 * (getStockFilters), поэтому здесь нет ни загрузки справочника, ни зависимостей между
 * полями: выбрали город — бэк сам вернул только его ДЦ.
 */
const SelectFacet = ({ options = [], handleSetSelect, handleSetState, ...props }) => (
  <Select
    handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
    handleSetState={handleSetState}
    options={options}
    formatOptionLabel={formatOptionLabel}
    isSearchable
    isClearable
    {...props}
  />
);

export default SelectFacet;
